import React from 'react';
import { Box, Stack, TextField } from '@mui/material';
import { normalizeHex } from '../../utils/color';

function ColorField({ label, value, onChange, disabled, placeholder }) {
  const safeValue = normalizeHex(value, placeholder || '#000000');
  return (
    <Stack direction="row" spacing={1.5} alignItems="center">
      <TextField
        fullWidth
        label={label}
        placeholder={placeholder}
        value={value}
        onChange={(event) => onChange(event.target.value)}
        disabled={disabled}
      />
      <Box
        component="input"
        type="color"
        value={safeValue}
        onChange={(event) => onChange(event.target.value)}
        disabled={disabled}
        aria-label={`${label} picker`}
        sx={{
          width: 46,
          height: 46,
          p: 0,
          borderRadius: 2,
          border: '1px solid',
          borderColor: 'divider',
          background: 'transparent',
          cursor: disabled ? 'not-allowed' : 'pointer',
          '&::-webkit-color-swatch-wrapper': { p: 0 },
          '&::-webkit-color-swatch': { border: 'none', borderRadius: 8 },
          '&::-moz-color-swatch': { border: 'none', borderRadius: 8 },
        }}
      />
    </Stack>
  );
}

export default ColorField;
